import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OtaBatchReportsComponent } from './ota-batch-reports.component';

const routes: Routes = [
  {
    path: 'Ota-batch-report',
    component: OtaBatchReportsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchReportsRoutingModule {}
